const steps = [
  {
    num: "01",
    icon: "ri-file-list-3-line",
    title: "訂單確認",
    desc: "客戶提交訂單需求,我們會在24小時內確認產品規格、數量、價格和交貨期,並簽訂正式合同。",
  },
  {
    num: "02",
    icon: "ri-search-line",
    title: "質檢包裝",
    desc: "從合作果園採摘新鮮水果,經過嚴格的品質檢測和分級,使用專業包裝材料進行包裝,確保運輸安全。",
  },
  {
    num: "03",
    icon: "ri-truck-line",
    title: "物流配送",
    desc: "採用冷鏈物流運輸,全程溫控監測。提供海運、空運等多種運輸方式,確保水果以最佳狀態送達目的地。",
  },
  {
    num: "04",
    icon: "ri-shield-check-line",
    title: "清關服務",
    desc: "協助客戶辦理進口清關手續,提供完整的出口文件和檢疫證明,確保順利通關。",
  },
  {
    num: "05",
    icon: "ri-customer-service-2-line",
    title: "售後支持",
    desc: "提供全程跟蹤服務,及時反饋物流信息。如有任何問題,我們的客服團隊隨時為您解決。",
  },
  {
    num: "06",
    icon: "ri-hand-heart-line",
    title: "長期合作",
    desc: "建立長期合作關係,提供穩定的貨源保障和優惠價格,共同開拓市場,實現雙贏。",
  },
];

export default function ProcessSection() {
  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-16">
          <div className="text-sm text-gray-500 mb-3">我們的服務流程</div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            專業高效的
            <br />
            出口服務體系
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className="group bg-gray-50 rounded-2xl p-8 hover:bg-orange-50 transition-all duration-300 hover:shadow-lg"
            >
              <div className="space-y-4">
                <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl shadow-sm group-hover:bg-orange-700 group-hover:shadow-md transition-all">
                  <i className={`${step.icon} text-2xl text-orange-700 group-hover:text-white transition-colors`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-orange-700 mb-2">{step.num}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 bg-gradient-to-br from-orange-700 to-orange-900 rounded-3xl p-10 text-center text-white">
          <div className="max-w-3xl mx-auto space-y-6">
            <h3 className="text-3xl font-bold">完善的供應鏈管理系統</h3>
            <p className="text-orange-100 leading-relaxed">
              我們建立了從果園到客戶的完整供應鏈體系,每個環節都有專業團隊負責,確保水果品質和交貨時效。通過數字化管理系統,客戶可以實時追蹤訂單狀態,讓合作更加透明、高效。
            </p>
            <div className="grid md:grid-cols-4 gap-6 pt-6">
              {[
                { val: "2000+", label: "公頃果園" },
                { val: "5個", label: "包裝中心" },
                { val: "24小時", label: "冷鏈運輸" },
                { val: "98%", label: "客戶滿意度" },
              ].map((stat, i) => (
                <div key={i} className="space-y-2">
                  <div className="text-3xl font-bold">{stat.val}</div>
                  <div className="text-sm text-orange-200">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
